import { env } from '@/env'

/**
 * Unset VITE_TWO_FACTOR_ENFORCEMENT_DATE means the rollout grace period never ends — this
 * only gates the frontend banner/redirect; the backend SessionGuard is the actual
 * enforcement point and is configured independently via TWO_FACTOR_ENFORCEMENT_DATE.
 */
export function isPastTwoFactorEnforcementDate(): boolean {
  if (!env.VITE_TWO_FACTOR_ENFORCEMENT_DATE) return false
  return new Date() >= new Date(env.VITE_TWO_FACTOR_ENFORCEMENT_DATE)
}

/**
 * Retrying send/verify on the same page can never succeed once this fires — the cookie is
 * gone.
 */
export const TWO_FACTOR_SESSION_EXPIRED_CODE = 'TWO_FACTOR_SESSION_EXPIRED'

export const TWO_FACTOR_SESSION_EXPIRED_MESSAGE =
  'Your verification session has expired. Please sign in again.'

interface TwoFactorAuthError {
  code?: string
  message?: string | null
}

/** Maps better-auth's "Invalid two factor cookie" to a message the user can act on. */
export function resolveTwoFactorAuthError(
  error: TwoFactorAuthError,
  fallback: string,
): { code: string; message: string } {
  if (error.code === 'INVALID_TWO_FACTOR_COOKIE') {
    return {
      code: TWO_FACTOR_SESSION_EXPIRED_CODE,
      message: TWO_FACTOR_SESSION_EXPIRED_MESSAGE,
    }
  }
  return { code: 'AUTH_ERROR', message: error.message ?? fallback }
}
